import { RouterView } from "vue-router";
import { LicenseBorrowRouting } from "./license-borrow/license-borrow.routing";
import { LicenseCategoryRouting } from "./license-category/license-category.routing";
import { LicenseHoldRouting } from "./license-hold/license-hold.routing";
import { LicenseListRouting } from "./license-list/license-list.routing";
export const LicenseManageRouting = {
  path: "/license-manage",
  name: "license-manage",
  redirect: "/license-manage/license-category/list",
  component: RouterView,
  meta: { title: "证照管理", icon: "license" },
  children: [
    ...LicenseCategoryRouting,
    ...LicenseListRouting,
    ...LicenseHoldRouting,
    ...LicenseBorrowRouting
  ],
};
